/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkforceProjectManagerResource
 */
export interface WorkforceProjectManagerResource {
    /**
     * Project manager account id
     * @type {string}
     * @memberof WorkforceProjectManagerResource
     */
    accountId: string;
    /**
     * Project manager first name
     * @type {string}
     * @memberof WorkforceProjectManagerResource
     */
    firstName: string;
    /**
     * Project manager last name
     * @type {string}
     * @memberof WorkforceProjectManagerResource
     */
    lastName: string;
    /**
     * Project manager photo URL
     * @type {string}
     * @memberof WorkforceProjectManagerResource
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the WorkforceProjectManagerResource interface.
 */
export function instanceOfWorkforceProjectManagerResource(value: object): value is WorkforceProjectManagerResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function WorkforceProjectManagerResourceFromJSON(json: any): WorkforceProjectManagerResource {
    return WorkforceProjectManagerResourceFromJSONTyped(json, false);
}

export function WorkforceProjectManagerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkforceProjectManagerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function WorkforceProjectManagerResourceToJSON(value?: WorkforceProjectManagerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photoUrl': value['photoUrl'],
    };
}

